import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './RecommendationOfferDesktopSkeleton.css';

export const RecommendationOfferDesktopSkeleton: React.FC = () => (
  <div className={styles['container']} data-name="RedesignedRecommendationOfferDesktopSkeleton">
    <div className={clsx(styles['skeleton'], styles['image'])} />
    <div className={clsx(styles['skeleton'], styles['primary-line'])} />
    <div className={styles['skeleton']} />
  </div>
);
